module.exports = __webpack_public_path__ + "assets/images/02_dfaa29d33ad2bb435b12d5abacc82b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/02.png
// module id = 225
// module chunks = 0